type ErrorEnvelope = {
  data?: {
    error?: {
      code?: unknown;
      message?: unknown;
      fields?: unknown;
    };
  };
};

function isErrorEnvelope(error: unknown): error is ErrorEnvelope {
  return typeof error === 'object' && error !== null && 'data' in error;
}

export function getApiErrorCode(error: unknown): string | null {
  if (!isErrorEnvelope(error)) return null;
  const code = error.data?.error?.code;

  return typeof code === 'string' && code !== '' ? code : null;
}

export function getApiErrorMessage(error: unknown): string | null {
  if (!isErrorEnvelope(error)) return null;
  const message = error.data?.error?.message;

  return typeof message === 'string' && message !== '' ? message : null;
}

export function getApiErrorField(error: unknown, name: string): string | number | null {
  if (!isErrorEnvelope(error)) return null;
  const fields = error.data?.error?.fields;
  if (typeof fields !== 'object' || fields === null) return null;
  const value: unknown = Reflect.get(fields, name);

  return typeof value === 'string' || typeof value === 'number' ? value : null;
}
